module.exports = __webpack_public_path__ + "img/newSuccess.2dcd397b.png";